import React, { FC } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Order } from 'models/order';

type BatchMoveNextStepConfirmDialogProps = {
    open: boolean;
    movableCount: number;
    unmovableOrders: Order[];
    onClose: () => void;
    onConfirm: () => void;
};

const BatchMoveNextStepConfirmDialog: FC<BatchMoveNextStepConfirmDialogProps> = ({
    open,
    movableCount,
    unmovableOrders,
    onClose,
    onConfirm,
}: BatchMoveNextStepConfirmDialogProps) => {
    const { t: translate } = useTranslation(['common', 'workflow']);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{translate('workflow:MOVE_TO_NEXT_STEP')}</DialogTitle>
            <DialogContent>
                {unmovableOrders.length ? (
                    <Box mb={2}>
                        <Alert severity="info">
                            {translate('workflow:NO_NEXT_STEP_INFO', {
                                orderIds: unmovableOrders.map((order) => order.orderId).join(', '),
                            })}
                        </Alert>
                    </Box>
                ) : undefined}
                {movableCount ? <Typography>{translate('workflow:MOVE_TO_NEXT_STEP_CONFIRM')}</Typography> : undefined}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{translate('common:CANCEL')}</Button>
                {movableCount ? (
                    <Button variant="contained" onClick={onConfirm} autoFocus>
                        {translate('workflow:MOVE_TO_NEXT_STEP')}
                    </Button>
                ) : undefined}
            </DialogActions>
        </Dialog>
    );
};

export default BatchMoveNextStepConfirmDialog;
